const mutationVariables = <T>(variables: T) => {
  return {
    variables: {
      input: {
        ...variables,
      },
    },
  };
};

export default mutationVariables;
